import { render, staticRenderFns } from "./ImChat.vue?vue&type=template&id=7bf67a5c&"
import script from "./ImChat.vue?vue&type=script&lang=js&"
export * from "./ImChat.vue?vue&type=script&lang=js&"
import style0 from "./ImChat.vue?vue&type=style&index=0&id=7bf67a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports